import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader: React.FC = () => (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh" sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
    }}>
        <CircularProgress sx={{ color: '#f55c47' }} />
    </Box>
);

export default Loader;